// extracted by mini-css-extract-plugin
export default {"title":"u_-z","warning":"v_-z","sizeOptionsLegendText":"w_-z"};